import { IApplicationState } from '../../../../types/types';
import { ISnackbarModel, TSnackbarId } from '../store/types';

export const getSnackbar = (
    state: IApplicationState,
    snackbarId: TSnackbarId
): ISnackbarModel => {
    const snackbar = state.snackbarsStack.snackbars.filter(item => {
        return item.id === snackbarId;
    });
    return snackbar[0];
}
